import { SIDENAV_TOKENS } from '@app/components/layout/sidenav/sidenav-tokens';
import { useSidenavContext } from '@app/components/layout/sidenav/SidenavContext';
import { useUiStore } from '@app/core/ui/stores/ui.store';
import { useVersionCheck } from '@app/core/version-check/useVersionCheck';
import { Brand } from '@mi-front/ui';
import { Badge, Box, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { config } from '../../../../../config';

const versionUpdateExpandTooltipMessage = defineMessage({
  id: 'ui.versionChecker.newVersionAvailableExpand',
  defaultMessage: 'Nueva versión disponible, click para expandir',
});

/**
 * Mini brand mark for the identity row. When collapsed and a new build is available,
 * shows a top-right badge; click expands the sidenav so the update control is visible.
 */
export function SidenavBrandMark() {
  const { collapsed } = useSidenavContext();
  const { isNewVersionAvailable } = useVersionCheck();
  const toggleSidenav = useUiStore((state) => state.toggleSidenav);
  const intl = useIntl();

  const tokens = SIDENAV_TOKENS;
  const showVersionBadge = collapsed && isNewVersionAvailable;
  const versionLabel = config.isAppDev ? `${config.appVersion} · local` : config.appVersion;
  const tooltip = showVersionBadge
    ? intl.formatMessage(versionUpdateExpandTooltipMessage)
    : versionLabel;

  const brand = (
    <Box
      onClick={showVersionBadge ? () => toggleSidenav(true) : undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: showVersionBadge ? 'pointer' : 'default',
        img: {
          height: tokens.brandMarkHeight,
          width: 'auto',
        },
      }}
    >
      {/* Always use mini mark — decoupled from sidenav expanded state */}
      <Brand collapsed isAppDev={config.isAppDev} />
    </Box>
  );

  return (
    <Tooltip title={tooltip} placement="right">
      <Box component="span" sx={{ display: 'inline-flex', lineHeight: 0 }}>
        {showVersionBadge ? (
          <Badge color="warning" variant="dot" overlap="circular">
            {brand}
          </Badge>
        ) : (
          brand
        )}
      </Box>
    </Tooltip>
  );
}
